import React from 'react'
import classNames from 'classnames'
import { setup, styled } from 'goober'
import { getStaticGlassMorphIconPath } from './helpers'
import type { IGlassMorphIconProps } from './interfaces'
import './styles.scss'

setup(React.createElement)

type Props = IGlassMorphIconProps & {
  className?: string
}

const BaseGlassMorphIcon: React.FC<Props> = ({ className, modifiers, ...rest }) => {
  const cn = classNames(
    'glass-morph-icon',
    className,
    modifiers?.map(m => `glass-morph-icon_${m}`),
  )

  return <span className={cn} {...rest} />
}

const GlassMorphIcon = styled(BaseGlassMorphIcon)<Props>(props => ({
  'background-image': `url("${getStaticGlassMorphIconPath(props.image)}")`,
  ...(props.hoverImage && {
    '&::before': {
      'background-image': `url("${getStaticGlassMorphIconPath(props.hoverImage)}")`,
    },
  }),
}))

export default GlassMorphIcon
